import { authHeader } from './auth';
import { wrapRequest } from './nav';
/* eslint-disable no-alert, no-console ,  no-debugger */

const vueAppMagenotApiUrl = process.env.VUE_APP_MAGENTO_API_URL;
// const vueAppCraneOrderUrl = process.env.VUE_APP_CRANE_ORDER_URL;
// const imageLibApiUrl = process.env.VUE_APP_IMAGE_LIB_URL;
//const vueAppCustomCachePath = process.env.VUE_APP_CUSTOM_CACHE_PATH;

export const doFetchSavedForLaterList = wrapRequest(() => {
    // eslint-disable-next-line no-debugger
    // debugger
    const requestOptions = {
        method: 'GET',
        headers: {
            'Content-type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            ...authHeader()
        }
    };
    return fetch(`${vueAppMagenotApiUrl}/rest/V1/wishlist`, requestOptions)
});

export const doAddToSavedForLater = wrapRequest(({sku}) => {
    const requestOptions = {
        method: 'POST',
        headers: {
            'Content-type': 'application/json',
            ...authHeader()
        },
        body: JSON.stringify(
            {
                "wishlistItem":
                {
                "sku": sku
                }
                }
        )
    };
    return fetch(`${vueAppMagenotApiUrl}/rest/V1/wishlist/add`, requestOptions);
});

export const doDeleteWishlistProduct = ((itemId) => {
    const requestOptions = {
        method: 'DELETE',
        headers: {
            'Content-type': 'application/json',
            ...authHeader()
        }
    };
    return fetch(`${vueAppMagenotApiUrl}/rest/V1/wishlist/remove/`+itemId, requestOptions)
})

